import { getFilterStorageKey } from "containers/ExecutionFilter/filterStorage";

export const importedTabKey = "imported";
export const updateTabKey = "update";

/** localStorage keys (version suffix applied by storage helpers) */
export const bundleManagerTableSettingsKey = "bundle_manager";
export const bundleManagerActiveTabStorageKey = "bundle_manager_active_tab";
export const bundleManagerPaginationStorageKey = "bundle_manager_pagination";

export const bundleManagerLogFilterRecordType = "bundle-manager";

export const getBundleManagerLogFilterStorageKey = (workspaceId: string) =>
    getFilterStorageKey({
        page: "log-filter",
        recordType: bundleManagerLogFilterRecordType,
        recordId: workspaceId,
    });
